var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPregnantWomanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.959 19.8799C12.959 19.8799 15.329 17.8978 17.5697 19.0827C17.5697 19.0827 20.1983 20.5694 19.4011 23.4349L15.7384 32.0962",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7943 54.0724C44.9971 46.0791 43.9414 33.8628 34.8062 28.1533C36.8745 22.7239 32.6516 18.6733 29.269 18.6733H16.1694L6.49547 49.2247C6.49547 49.2247 5.91376 53.8785 5.15967 60.019H46.3545C46.1175 57.6705 45.9236 55.6237 45.7728 54.094L45.7943 54.0724Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3544 59.782C46.1389 57.5198 45.945 55.5376 45.7942 54.0509C44.997 46.0576 43.9413 33.8414 34.8061 28.1318C36.8744 22.7024 32.6515 18.6519 29.2689 18.6519H16.1693L6.49536 49.2032C6.49536 49.2032 5.93518 53.7493 5.20264 59.782H46.3544Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8119 18.8026C12.9159 16.6911 12.5711 12.0804 15.9753 10.3352C13.6484 5.55215 17.2681 2.29879 20.8015 3.87161C20.8015 0.359709 25.2398 -0.760653 27.0712 2.40652C27.2651 2.75125 27.5237 3.2037 27.7607 3.65615L19.875 8.1376C19.3795 8.41769 19.2072 9.02096 19.4657 9.53805C19.9612 10.486 20.6722 11.865 20.8446 12.2528C21.1031 12.8345 21.2539 13.6532 21.2539 14.4073V18.6518C19.0348 18.6518 16.751 18.6518 16.3201 18.6733C15.3936 18.6733 14.855 18.8026 14.855 18.8026H14.8119Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4695 11.391C20.9524 9.99054 22.3745 8.35309 23.8827 10.0983L29.269 7.125C29.2906 7.38354 29.3121 7.64209 29.269 7.96527C29.0536 10.7015 28.795 13.6102 28.795 13.6102C28.6011 15.1183 27.3514 16.2602 25.8433 16.3249V18.6302C25.8433 18.6302 23.5595 18.6302 21.2326 18.6302V14.3858C21.2326 13.6102 21.0817 12.813 20.8232 12.2313C20.7801 12.1666 20.737 12.0589 20.6724 11.9296L21.5127 11.4556V11.391C21.4911 11.391 21.4911 11.391 21.4911 11.391H21.4695Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8193 12.9814H52.9043C53.3302 12.9814 53.6843 13.3349 53.6846 13.7607C53.6846 14.0315 53.6111 14.1778 53.5371 14.2666C53.4558 14.3641 53.3151 14.4597 53.082 14.5273L49.5645 15.4717L49.1592 15.5801L49.04 15.9834L44.4287 31.5605L44.4277 31.5625C44.0115 32.9874 42.6183 33.8355 41.2461 33.6914L40.8252 33.0293H40.8242C40.0666 31.8153 38.7249 30.3861 38.4355 30.0762L38.4268 30.0674L38.418 30.0576L38.0596 29.7041C37.6534 29.3084 37.1046 28.801 36.4385 28.3057L36.4014 28.2783L36.3613 28.2549L35.543 27.791L36.0791 25.2031L36.1152 25.0283L36.0693 24.8555L35.6104 23.1611L39.3457 26.2734L40.084 26.8887L40.502 26.0234L46.3623 13.8936L46.3643 13.8887C46.6245 13.3393 47.1962 12.9816 47.8193 12.9814Z",
    fill: "white",
    stroke: "#005FC8",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0396 20.2249L38.7059 24.8787L36.1421 29.0585C35.7327 28.7353 35.2802 28.4337 34.7847 28.132C35.9912 25.3311 35.1295 22.0778 33.0396 20.2249Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6257 18.6519H19.0351C20.6295 18.6519 21.9006 19.9446 21.9006 21.5175V50.6468C15.4801 51.6164 10.5462 50.2159 8.02537 49.4618C5.48301 48.7078 4.92285 49.6127 4.92285 49.6127C4.92285 49.6127 5.11675 46.2731 6.36638 43.9031L11.0633 35.9098L16.5789 18.6304H18.6257V18.6519Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06066 38.3442L8.5852 28.8643L15.609 32.4408L14.1008 35.9312L22.3527 35.0478L25.843 31.8806C26.3386 31.4713 27.0927 31.4713 27.5667 31.9022C28.0407 32.3115 28.1484 33.0225 27.8252 33.5612L26.2093 36.7714C25.4121 38.1503 24.1194 39.1845 22.5897 39.637L8.1758 43.8599C5.99972 44.5278 3.73744 43.0842 3.4789 40.822C3.37117 39.917 3.58666 39.0552 4.06066 38.3658V38.3442Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58545 28.8645L12.4636 20.785C13.1746 19.3199 14.7259 18.4796 16.3418 18.6951C18.8195 19.0183 20.3061 21.6468 19.2935 23.9306L15.6092 32.4626L8.58545 28.886V28.8645Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92242 49.6343C4.55615 50.3668 5.18097 51.2502 6.21515 51.4656L6.49519 49.2034C6.49519 49.2034 5.20251 49.0526 4.92242 49.6343Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5898 13.5671C22.7622 15.1399 24.098 16.3249 25.6924 16.3249C27.2867 16.3249 28.5794 15.1615 28.7949 13.6102C28.7949 13.6102 29.0535 10.7016 29.2689 7.96533C29.312 7.31897 29.2473 6.88806 29.1181 6.43561C28.9888 5.98315 27.8038 3.6778 27.0497 2.38507C25.2399 -0.782103 20.78 0.359803 20.78 3.85016C17.2466 2.27734 13.6269 5.50916 15.9539 10.3138C12.5497 12.0374 12.8944 16.6481 14.7904 18.7811",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5898 13.5671C22.7622 15.1399 24.098 16.3249 25.6924 16.3249C27.2867 16.3249 28.5794 15.1615 28.7949 13.6102C28.7949 13.6102 29.0535 10.7016 29.2689 7.96533C29.312 7.31897 29.2473 6.88806 29.1181 6.43561C28.9888 5.98315 27.8038 3.6778 27.0497 2.38507C25.2399 -0.782103 20.78 0.359804 20.78 3.85016C17.2466 2.27734 13.6269 5.50916 15.9539 10.3138C12.5497 12.0374 12.8944 16.6481 14.7904 18.7811",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8433 16.3679V18.6302",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3959 12.4253C20.1552 11.1541 21.9435 7.85766 23.8826 10.0768",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6509 11.9297C21.1464 12.8777 20.6293 11.865 20.8017 12.2313C21.0602 12.813 21.211 13.6318 21.211 14.3859V18.6519",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4911 11.4558L20.6724 11.9298",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9556 25.9127L32.6948 19.9446",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3529 35.0479L25.8433 31.8807C26.3603 31.4713 27.0929 31.4713 27.5669 31.9238C28.0409 32.3331 28.1486 33.0441 27.8254 33.5828L26.2095 36.793C25.4123 38.172 24.1197 39.2061 22.5899 39.6586L8.17603 43.8815C5.99994 44.5494 3.73767 43.1058 3.47912 40.8436C3.24212 38.8614 4.62103 37.0516 6.6032 36.793L22.3529 35.091V35.0479Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06074 38.3443L6.77543 32.6995M14.1009 35.9313L19.2933 23.9305C20.306 21.6251 18.8193 19.0181 16.3416 18.6949C14.7257 18.4795 13.1744 19.3413 12.4634 20.7848L10.5244 24.8354H1.41064",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6092 32.4408L8.58545 28.8643",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9221 39.8096V50.6684C15.5016 51.638 10.5677 50.2375 8.04691 49.4835C5.50455 48.7294 4.94434 49.6343 4.94434 49.6343C4.94434 49.6343 5.13827 46.2947 6.36635 43.9247",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6255 18.6519H19.0349C20.6292 18.6519 21.9004 19.9446 21.9004 21.5174V35.0695",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92283 49.6343C4.59965 50.3884 5.18137 51.2502 6.21555 51.4656",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0113 10.5077C23.9472 10.2201 23.9258 9.93247 23.9258 9.62275C23.9258 7.36626 25.4459 5.55615 27.5397 5.55615C29.6335 5.55615 28.4503 5.76771 28.8812 5.87543",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.706 24.8784L36.1421 29.0582",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9946 30.6957C38.0162 30.2217 38.1239 29.7477 38.3393 29.2953L41.3557 23.0471",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregnantWomanIcon);
export default __webpack_public_path__ + "static/media/pregnant-woman-icon.3eaa6832.svg";
export { ForwardRef as ReactComponent };